module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-inner"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props && !_vm.loading) ? _c('div', {
    staticClass: "inner-inner-wrap"
  }, [_c('Header'), _c('div', {
    staticClass: "subnav_menu"
  }, [_c('div', {
    staticClass: "container_manual clearfix"
  }, [_c('ul', [_c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/common-orthodontic-issues"
    }
  }, [_c('span', [_vm._v("Common Orthodontic Issues")])])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/early-orthodontic-treatment"
    }
  }, [_c('span', [_vm._v("Early Orthodontic Treatment")])])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/surgical-orthodontics"
    }
  }, [_c('span', [_vm._v("Surgical Orthodontics")])])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/itero-element"
    }
  }, [_c('span', [_vm._v("iTero® Element™ ")])])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/tmj-tmd"
    }
  }, [_c('span', [_vm._v("TMJ-TMD ")])])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/sleep-apnea"
    }
  }, [_c('span', [_vm._v("Sleep Apnea ")])])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/invisalign-treatment"
    }
  }, [_c('span', [_vm._v("Invisalign® Treatment")])])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/invisalign-treatment-for-teens"
    }
  }, [_c('span', [_vm._v("Invisalign® Treatment for Teens ")])])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/in-ovation"
    }
  }, [_c('span', [_vm._v("In-Ovation®")])])], 1)])])]), _c('div', {
    staticClass: "content_section"
  }, [_c('div', {
    staticClass: "container_manual clearfix"
  }, [_c('div', {
    staticClass: "content_left"
  }, [(_vm.props.title.rendered) ? _c('h1', {
    staticClass: "main_title",
    domProps: {
      "innerHTML": _vm._s(_vm.props.title.rendered)
    }
  }) : _vm._e(), (_vm.props.content.rendered) ? _c('div', {
    staticClass: "content_all",
    domProps: {
      "innerHTML": _vm._s(_vm.props.content.rendered)
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "content_right"
  }, [(_vm.props.better_featured_image) ? _c('div', {
    attrs: {
      "id": "featured_img"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.props.better_featured_image.source_url,
      "alt": ""
    }
  })]) : _vm._e(), (_vm.propsheader.acf.fish_img) ? _c('u-animate-container', {
    staticClass: "wow-wrap"
  }, [_c('u-animate', {
    staticClass: "fishscroll",
    attrs: {
      "name": "bounceInRight",
      "delay": "0s",
      "duration": "1.2s",
      "iteration": 1,
      "offset": 0,
      "animateclass": "animated",
      "begin": false
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.propsheader.acf.fish_img,
      "alt": "",
      "width": "264"
    }
  })])], 1) : _vm._e()], 1)])]), _c('Footer')], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68ef4b38","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/tmj-tmd/tmj-tmd.pug
// module id = 603
// module chunks = 1